
import {
  WaitObjectByPathPromise,
  RejectionReasons,
} from "app/wait_object_by_path_promise"

import {
  captureException,
} from "app/error_reporting/index"


const onLoad = () => {
  // This is for adding the classname for CSS
  WaitObjectByPathPromise("Modernizr")
  .then((Modernizr) =>
    Modernizr.addTest("inputmultiple", !!(Modernizr.input.multiple))
  )
  .catch((whatever) => {
    if (whatever instanceof Error) {
      captureException(whatever, {
        source_file_path: "plugins/modernizr/inputmultiple/onload",
      })

      return
    }

    if (typeof whatever === "object") {
      const { rejection_reason } = whatever

      if (rejection_reason === RejectionReasons.TIMEOUT) {
        // Normal to be timeout
        return
      }
    }

    throw whatever
  })
  .done()
}


export default onLoad
